import { useDialogMakePaymentContext } from '../dialogMakePaymentContext';
import useStripePayNow from '../useStripePayNow';
import ConfirmPaymentContent from './ConfirmPayment';

/** Confirms a payment on a newly entered Stripe card. */
const ConfirmNewStripePayment = () => {
	const { accountBalanceDisplay, confirmationToken, formValues } =
		useDialogMakePaymentContext();
	const { payNow, isPaying } = useStripePayNow();

	const { amount, savePaymentMethod } = formValues;

	const handleSubmit = () => {
		if (!confirmationToken) return;

		payNow({
			kind: 'newCard',
			amount,
			confirmationToken,
			savePaymentMethod,
		});
	};

	return (
		<ConfirmPaymentContent
			accountBalance={Number(accountBalanceDisplay)}
			amount={Number(amount)}
			isSubmitting={isPaying}
			onSubmit={handleSubmit}
			paymentMethod="credit_card"
			label="Card"
		/>
	);
};

export default ConfirmNewStripePayment;
